<template>
  <div>
    <div class="safe-left">
      <div class="risk-type-box">
        <div class="module-title">
          <div class="title-box">
            食品安全监督信息公示
          </div>
          <el-tooltip
            class="item"
            effect="light"
            :content="schoolName"
            placement="top"
          >
            <div class="school-box" @click="selectSchool">
              {{ schoolName }}
            </div>
          </el-tooltip>
        </div>
        <food-safety-kitchen :canteenData="canteenData"></food-safety-kitchen>
      </div>
    </div>
    <div class="ingredient-title">
      <module-title title="本周食材"></module-title>
    </div>
    <div class="ingredient-content">
      <hidden-danger-pie
        v-if="WeekIngredients.length > 0"
        :echartsData="WeekIngredients"
        type="h"
      ></hidden-danger-pie>
      <div v-else class="noData">
        暂无数据
      </div>
    </div>
    <div class="purchase-title">
      <module-title title="食材采购趋势"></module-title>
    </div>
    <div class="purchase-module">
      <food-safety-line
        :canteenData="canteenData"
        v-if="canteenData.id"
      ></food-safety-line>
      <div v-else class="noData">
        暂无数据
      </div>
    </div>
    <div class="risk-dialog">
      <el-dialog
        class="hidden-detail-dlialog"
        title="食堂切换"
        :modal-append-to-body="false"
        :append-to-body="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="schoolVisible"
        width="30%"
      >
      <div class="content">
          <div class="hidden-close" @click="closeClick">
					关闭
				</div>
        <div class="table-wrapper">
          <el-table
            :data="foodList"
            @row-click="schoolSelect"
            style="width: 100%"
            max-height='300px'
            border
          >
            <el-table-column
              label="序号"
              width="50"
              align="center"
              type="index"
            >
            </el-table-column>
            <el-table-column
              prop="schoolName"
              align="center"
              show-overflow-tooltip
              label="食堂名称"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import foodSafetyKitchen from "./foodSafetyKitchen";
import moduleTitle from "./moduleTitle";
import foodSafetyLine from "./foodSafetyLine";
import hiddenDangerPie from "./hiddenDangerPie";
export default {
  name: "foodStatistics",
  data() {
    return {
      foodList: [],
      canteenData: {},
      schoolName: "",
      WeekIngredients: [],
      schoolVisible: false,
      selectedSchoolId: ""
    };
  },
  components: {
    foodSafetyKitchen,
    moduleTitle,
    foodSafetyLine,
    hiddenDangerPie
  },
  created() {
    this.getfoodList();
  },
  methods: {
    async getfoodList() {
      let res = await this.$Http.getCanteenUnder({ eduId: this.eduInfo.eduId });
      if (res.code == 200) {
        this.foodList = res.data || [];
      } else if (res.code == 101) {
        this.foodList = [];
      } else {
        this.foodList = [];
      }
      if (this.foodList.length != 0) {
        this.getCanteenInfo(this.foodList[0].schoolId);
        this.getThisWeekIngredients(this.foodList[0].schoolId);
        this.selectedSchoolId = this.foodList[0].schoolId;
        this.schoolName = this.foodList[0].schoolName || "";
      }
    },
    // 校园食品安全-获取食堂信息
    async getCanteenInfo(id) {
      var newParamData = {
        schoolId: id
      };
      let res = await this.$Http.getCanteenInfo(newParamData);
      if (res.code == 200) {
        this.canteenData = res.data[0];
      } else if (res.code == 101) {
        this.canteenData = {};
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "食堂信息获取失败"
        });
      }
    },
    // 校园食品安全-获取本周食材
    async getThisWeekIngredients(id) {
      var newParamData = {
        schoolId: id
      };
      let res = await this.$Http.getThisWeekIngredients(newParamData, true);
      if (res.code == 200) {
        let data = res.data || [];
        this.WeekIngredients = data.map((item) => {
          let name = this.classify(item.typeSpecification);
          let value = parseInt(item.getToTal);
          return {
            name: name || "",
            value: value || 0
          };
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "本周食材获取失败"
        });
      }
    },
    classify(type) {
      // console.log(element)
      let name = "";
      switch (type) {
        case 0:
          name = "肉类";
          break;
        case 1:
          name = "蔬菜";
          break;
        case 2:
          name = "水果";
          break;
        case 3:
          name = "饮品";
          break;
        case 4:
          name = "豆制品";
          break;
        case 5:
          name = "调味品";
          break;
        case 6:
          name = "水产品";
          break;
        case 7:
          name = "食用油";
          break;
        case 8:
          name = "粮谷类(米、面)";
          break;
        case 9:
          name = "其他";
          break;
        default:
          break;
      }
      return name;
    },
    selectSchool() {
      if (this.foodList.length == 1) {
        this.$message({
          type: "warning",
          message: "无可切换食堂信息展示"
        });
      } else {
        this.schoolVisible = true;
      }
    },
    schoolSelect(item) {
      if (item.schoolId == this.selectedSchoolId) {
        this.$message({
          type: "warning",
          message: "当前页面已显示" + item.schoolName + "信息"
        });
      } else {
        this.schoolVisible = false;
        this.getCanteenInfo(item.schoolId);
        this.getThisWeekIngredients(item.schoolId);
        this.selectedSchoolId = item.schoolId;
        this.schoolName = item.schoolName || "";
        this.$message({
          type: "success",
          message: "食堂信息切换成功"
        });
      }
    },
    closeClick(){
        this.schoolVisible = false;
    }
  },
  computed: {
    eduInfo() {
      return JSON.parse(sessionStorage.getItem("eduInfo"));
    }
  }
};
</script>
<style scoped lang="scss">
.safe-left {
  position: absolute;
  top: 80px;
  left: 90px;
  width: 440px;
  height: 820px;
  display: flex;
  justify-content: center;
  background: url("~@/assets/img/bigDataCollge/food-chart-bg.png") center center
    no-repeat;
  background-size: 100% 100%;
  .module-title {
    height: 36px;
    width: 370px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .title-box {
    line-height: 36px;
    width: 215px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgb(203, 224, 255);
  }
  .school-box {
    line-height: 36px;
    width: 155px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgb(203, 224, 255);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    transition: transform 0.3s;
    &:hover {
      transform: scale(1.05);
    }
  }
  .foot-left-box {
    width: 100%;
    height: 100%;
  }
}
.ingredient-title {
  position: absolute;
  top: 600px;
  left: 560px;
}
.ingredient-content {
  position: absolute;
  top: 640px;
  left: 560px;
  width: 400px;
  height: 256px;
  background: url("~@/assets/img/schoolBigData/account-module-bg.png") center
    center no-repeat;
  background-size: 100% 100%;
  .noData {
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
}
.purchase-title {
  position: absolute;
  top: 600px;
  left: 990px;
}
.purchase-module {
  position: absolute;
  top: 640px;
  left: 990px;
  width: 400px;
  height: 256px;
  background: url("~@/assets/img/schoolBigData/account-module-bg.png") center
    center no-repeat;
  background-size: 100% 100%;
  .noData {
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
}
.risk-dialog {
  /deep/ .hidden-detail-dlialog {
    .el-dialog {
      width: 1140px;
      height: 700px;
      background: transparent;
    }
  }
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
}
.table-wrapper {
    margin-top: 35px;
  /deep/ .el-table {
    padding: 0px;
    background-color: transparent;
    .el-table__expanded-cell {
      background-color: transparent;
    }
    th,
    tr {
      background-color: transparent !important;
      &:hover td {
        background-color: transparent !important;
      }
    }
    .el-table--enable-row-transition {
      .el-table__body {
        td {
          background-color: transparent;
          color: #c4cdff;
        }
      }
    }
    .cell {
      background-color: transparent;
      color: #c4cdff;
    }
  }
}
.content {
	padding-top: 12px;
	width: 100%;
    background-color: rgb(21,40,82);
	background-size: 100% 100%;
	position: relative;
	.hidden-close {
		width: 56px;
		height: 24px;
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #d7deff;
		line-height: 25px;
		letter-spacing: 1px;
		position: absolute;
		top: 10;
		right: 0;
		cursor: pointer;
	}
	.content-title {
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 54px;
			height: 54px;
		}
		span {
			margin-left: 16px;
			font-size: 22px;
		}
	}
}
</style>
